module.exports = __webpack_public_path__ + "bg1.c941cb2319eea2cbf579.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/img/bg1.svg
// module id = ../../../../../src/assets/vcg/img/bg1.svg
// module chunks = styles